<template>
  <div>
  <div v-if="MType === 'MSG'" class="MSG-Message">
    <span>{{mmsg}}</span>
  </div>
  <div v-if="MType === 'ERR'" class="ERR-Message">
    <span>{{mmsg}}</span>
  </div>
  </div>
</template>

<script>
export default {
  name: 'MessageDisplay',
  props: ['mmsg', 'MType'],
  data () {
    return {
    }
  }
}
</script>
<style scoped>
.MSG-Message {
 color: black;
}
.ERR-Message {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageDisplay.vue